import { type ComputedRef, onBeforeUnmount, onMounted, watch } from 'vue'

export const useWatchOverlays = (show: ComputedRef<boolean>) => {
  onMounted(() => {
    const appWrapper = document.querySelector('#app-wrapper')

    if (show.value) {
      document.body.classList.add('!overflow-hidden')
      document.body.classList.add('no-overscroll')
      if (appWrapper) {
        appWrapper.classList.add('!overflow-hidden')
        appWrapper.classList.add('no-overscroll')
      }
    }
  })

  onBeforeUnmount(() => {
    const appWrapper = document.querySelector('#app-wrapper')
    document.body.classList.remove('!overflow-hidden')
    document.body.classList.remove('no-overscroll')
    if (appWrapper) {
      appWrapper.classList.remove('!overflow-hidden')
      appWrapper.classList.remove('no-overscroll')
    }
  })

  watch(show, show => {
    const appWrapper = document.querySelector('#app-wrapper')

    if (show) {
      document.body.classList.add('!overflow-hidden')
      document.body.classList.add('no-overscroll')
      if (appWrapper) {
        appWrapper.classList.add('!overflow-hidden')
        appWrapper.classList.add('no-overscroll')
      }
    } else {
      document.body.classList.remove('!overflow-hidden')
      document.body.classList.remove('no-overscroll')
      if (appWrapper) {
        appWrapper.classList.remove('!overflow-hidden')
        appWrapper.classList.remove('no-overscroll')
      }
    }
  })
}